import * as React from 'react';
import { TravelAd } from 'models';

export interface ListingTravelAdProps {
  travelAd?: TravelAd;
}

export const ListingTravelAd: React.FunctionComponent<ListingTravelAdProps> = ({ travelAd }) => {
  if (!travelAd) {
    return null;
  }

  const { brand, clickRedirectLinkoffTrackingUrl, detailsHeadline, details, logo, vanityurl } = travelAd;

  return (
    <React.Fragment>
      {detailsHeadline &&
        detailsHeadline !== 'null' &&
        details &&
        details !== 'null' && (
          <React.Fragment>
            <div
              className="uitk-type-200 uitk-type-bold uitk-neutral-700 all-t-padding-one all-b-padding-half"
              data-stid="content-hotel-details-headline"
            >
              {detailsHeadline}
            </div>
            <div className="uitk-type-200 uitk-weight-400 uitk-neutral-700 all-b-padding-two" data-stid="content-hotel-details">
              {details}
            </div>
          </React.Fragment>
        )}
      {clickRedirectLinkoffTrackingUrl && (
        <React.Fragment>
          <img className="all-t-margin-two all-b-margin-two all-r-margin-two" src={logo} alt={brand} />
          <a className="uitk-type-200">{vanityurl}</a>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
ListingTravelAd.displayName = 'ListingTravelAd';
